<template>
  <el-dialog :title="getTitle"
             :visible.sync="showModal"
             @close="handleCancel"
             width="40%">
    <el-col :span="24">
      <el-form :model="manInfo"
               :rules="manRules"
               ref="manForm"
               label-width="125px"
               class="man-form">
        <el-form-item label="员工卡号:"
                      prop="no">
          <el-input v-model.trim="manInfo.no"
                    placeholder="员工卡号">
          </el-input>
        </el-form-item>
        <el-form-item label="员工姓名:"
                      prop="name">
          <el-input v-model.trim="manInfo.name"
                    placeholder="请输入员工姓名"></el-input>
        </el-form-item>
        <el-form-item label="性别:"
                      prop="sex">
          <el-radio-group v-model="manInfo.sex">
            <el-radio label="1">男</el-radio>
            <el-radio label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <!--
        <el-form-item label="床位:"
                      prop="room_type_bed">
          <el-select v-model="manInfo.room_type_bed"
                     placeholder="请选择床铺">
            <el-option v-for="(item, index) in bedList"
                       :key="index"
                       :label="item.name"
                       :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        -->
        <el-form-item label="状态:"
                      prop="status">
          <el-select v-model="manInfo.status"
                     placeholder="请选择状态">
            <el-option label="正常"
                       value="1"></el-option>
            <el-option label="锁定"
                       value="2"></el-option>
            <el-option label="注销"
                       value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电话:"
                      prop="contact_ctx">
          <el-input v-model.trim="manInfo.contact_ctx"
                    placeholder="请输入电话"></el-input>
        </el-form-item>
        <el-form-item label="应急联系人:"
                      prop="back_person">
          <el-input v-model.trim="manInfo.back_person"
                    placeholder="请输入应急联系人"></el-input>
        </el-form-item>
        <el-form-item label="应急联系人电话:"
                      prop="back_contact_ctx">
          <el-input v-model.trim="manInfo.back_contact_ctx"
                    placeholder="请输入应急联系人电话"></el-input>
        </el-form-item>
        <el-form-item label="租赁开始日期:"
                      prop="effe_date">
          <el-date-picker v-model="manInfo.effe_date"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="租赁截止日期:"
                      prop="exp_date">
          <el-date-picker v-model="manInfo.exp_date"
                          value-format="yyyy-MM-dd"
                          type="date"
                          placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="备注:"
                      prop="remark">
          <el-input v-model.trim="manInfo.remark"
                    placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
    </el-col>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button v-has="'/person/add' || '/person/edit'"
                 type="primary"
                 @click="handleConfirm('manForm')">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
import validate from '@/common/validate'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      showModal: this.isShow,
      manInfo: {
        no: '',
        name: '',
        sex: '1',
        person_type: 'person_type_student',
        department_id: '1',
        person_job: 'student',
        room_type_bed: '',
        status: '1',
        contact_ctx: '',
        back_person: '',
        back_contact_ctx: '',
        effe_date: '',
        effe_time: '',
        exp_date: '',
        exp_time: '',
        remark: ''
      },
      manRules: {
        no: [{ required: true, message: '请输入员工工卡号' }],
        name: [{ required: true, message: '请输入员工名称' }],
        sex: [{ required: true, message: '请选择员工性别' }],
        status: [{ required: true, message: '请选择状态' }],
        contact_ctx: [
          { required: true, message: '请输入正确的手机号码' },
          { validator: validate.tel, trigger: 'change' }
        ],
        back_contact_ctx: [
          { required: false, message: '请输入正确的手机号码' },
          { validator: validate.tel, trigger: 'change' }
        ],
        effe_date: [{ required: true, message: '请选择租赁开始日期' }],
        exp_date: [{ required: true, message: '请选择租赁截止日期' }]
      },
      typeList: [],
      orgList: [],
      jobList: [],
      bedList: [],
      tmpArr: []
    }
  },
  computed: {
    getTitle() {
      return this.data.type === 'add' ? '添加员工' : '编辑员工'
    }
  },
  created() {
    if (this.data.type === 'edit') {
      this.getInfo()
    } else {
      const today = new Date()
      let yy = today.getFullYear()
      let mm = today.getMonth() + 1 < 10 ? '0' + (today.getMonth() + 1) : today.getMonth() + 1
      let dd = today.getDate() < 10 ? '0' + today.getDate() : today.getDate()
      this.manInfo.effe_date = yy + '-' + mm + '-' + dd
      this.manInfo.effe_time = '00:00'
      this.manInfo.exp_date = '2050-01-01'
      this.manInfo.exp_time = '23:00'
    }
  },
  methods: {
    //生成人员编号
    genNo() {
      fetch.getPersonNewNo({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.manInfo.no = data.newNo
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取编辑信息
    getInfo() {
      fetch.getPersonInfo({ id: this.data.id }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.manInfo = data
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.manInfo.exp_date <= this.manInfo.effe_date) {
            this.$message.error('截止日期不能小于或等于起始日期')
            return false
          }
          if (this.data.type === 'add') {
            fetch.addPerson({ ...this.manInfo }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          } else {
            fetch.editPerson({ ...this.manInfo }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          }
        } else {
          return false
        }
      })
    },
    handleCancel(type) {
      this.$emit('handleClose', type)
    },
    //  格式化名称
    titleFormat(data, prefix) {
      if (data.length === 0) {
        return []
      }
      data.forEach((item) => {
        let tmp = item
        tmp.name = prefix + item.name
        this.tmpArr.push(tmp)
        if (item.children && item.children.length > 0) {
          this.titleFormat(item.children, '• ' + prefix)
        }
      })
      return this.tmpArr
    }
  }
}
</script>

<style>
</style>
